module.exports = __webpack_public_path__ + "assets/img/thumb-fallback1.ade88f8d.jpg";